import { getRequestId, GLOBAL } from 'saddlebag-browser';
import { v4 as uuid } from 'uuid';

import {
  NEW_USER_STATUS_CHANGED,
  LOGGEDIN_STATUS_CHANGED,
  LOGGEDIN_STATUS_INITIALIZED,
} from '../../../../actions/user';

import type { Action } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { IdentifiersState } from '@web-platform/shared-universal-types/src/redux/state/appInitial/user/identifiers';

export type { IdentifiersState };

// Move "guid" out of getInitialState(), in order to prevent generating guid for several times in the tests.
const guid = uuid();

export function getInitialState() {
  const $window = GLOBAL.getWindow();
  // In production server will create a __internal object so the if statement should always be false.
  if (!$window?.__internal) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {} as IdentifiersState;
  }

  const { userInfo, viewId } = $window.__internal;

  return {
    guid,
    requestId: getRequestId(),
    utid: userInfo?.utid ?? null,
    isLoggedIn: userInfo?.isLoggedIn ?? null,
    isNewUser: userInfo?.isNewUser ?? null,
    viewId: viewId ?? null,
    isLoggedInWhenAppInit: null,
  };
}

export default function (
  state: IdentifiersState = getInitialState(),
  action: Action,
): IdentifiersState {
  switch (action.type) {
    case LOGGEDIN_STATUS_INITIALIZED: {
      return {
        ...state,
        isLoggedIn: action.payload.isLoggedIn,
        isLoggedInWhenAppInit: action.payload.isLoggedIn,
      };
    }

    case LOGGEDIN_STATUS_CHANGED: {
      return {
        ...state,
        isLoggedIn: action.payload.isLoggedIn,
      };
    }

    case NEW_USER_STATUS_CHANGED: {
      return {
        ...state,
        isNewUser: action.payload.isNewUser,
      };
    }

    default:
      return state;
  }
}
export const get = (state: IdentifiersState): IdentifiersState => state;
